import { render } from "./ClientLoginView.vue?vue&type=template&id=05246058"
import script from "./ClientLoginView.vue?vue&type=script&lang=js"
export * from "./ClientLoginView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__